// extracted by mini-css-extract-plugin
module.exports = {"swiper_button_next":"slider_swiper_button_next__EZaU4","swiper_button_prev":"slider_swiper_button_prev__AuhG1","pagination":"slider_pagination__Zj9OT"};